import React from 'react';
import LocalizedDate from '../../Localization/LocalizedDate';
import TitleDetailDrawer from '../TitleDetailDrawer';

export default function TitleBaseMeta({
	product,
	format,
	disableLink,
	communityId,
}) {
	const renderFrontListBackList = pubDate => {
		if (new Date(pubDate) > new Date()) {
			return 'FRONTLIST';
		} else {
			return 'BACKLIST';
		}
	};

	const renderProductNameWithDrawer = () => {
		return (
			<TitleDetailDrawer sku={product.sku} communityId={communityId}>
				<span className="acc-font">{product.name}</span>
			</TitleDetailDrawer>
		);
	};

	const renderProductName = () => {
		return disableLink ? (
			<span>{product.name}</span>
		) : (
			renderProductNameWithDrawer()
		);
	};

	return (
		<React.Fragment>
			<div
				style={{
					fontWeight: 'bold',
					fontSize: `${format === 'simple' ? 18 : 22}px`,
					marginTop: '2px',
				}}>
				{renderProductName()}
			</div>
			<div
				className="dotDot"
				style={{ fontSize: `${format === 'simple' ? 14 : 16}px` }}>
				{product.author}
				{product.series && (
					<span>&nbsp;&bull;&nbsp;Series: {product.series}</span>
				)}
			</div>
			<div className="dotDot">
				{product.supplier}&nbsp;&bull;&nbsp;
				<span className="bold">
					{renderFrontListBackList(product.pubDate)}
				</span>
				&nbsp;&#124;&nbsp;
				<LocalizedDate dateString={product.pubDate} />
			</div>
			<div className="dotDot">
				{product.format}&nbsp;&bull;&nbsp;
				{product.formattedPrices}
			</div>
			<div className="dotDot">
				{product.ean}&nbsp;&bull;&nbsp;
				{product.pages} pages&nbsp;&bull;&nbsp;
				{product.measurements}
			</div>
			{format !== 'simple' && <div>{product.category}</div>}
		</React.Fragment>
	);
}
